import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { BRAND, SITE_URL, localeUrl } from '../config/region';
import ParticleBackground from './ParticleBackground';
import SeoHead from './SeoHead';
import posts from './blogPosts';
import { t } from '../i18n';
import './BlogPage.css';

const BlogPage = () => {
  const description = t('Блог {0}: новости платформы, инструкции по созданию новелл, статьи о команде и возможностях сотрудничества.', BRAND);

  /* An ItemList of the posts, so the index can surface as a set of articles rather than one page.
     Each entry points at this language's URL for the post, which is the one that will rank. */
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Blog',
    name: t('Блог {0}', BRAND),
    description,
    url: localeUrl('/blog'),
    publisher: {
      '@type': 'Organization',
      name: BRAND,
      logo: { '@type': 'ImageObject', url: `${SITE_URL}/logo512.png` },
    },
    blogPost: posts.map((post) => ({
      '@type': 'BlogPosting',
      headline: post.seoTitle,
      description: post.seoDescription,
      datePublished: post.datePublished,
      dateModified: post.dateModified,
      url: localeUrl(`/blog/${post.slug}`),
    })),
  };

  return (
    <div className="bp-wrap">
      <SeoHead
        title={t('Блог')}
        description={description}
        imageAlt={t('Блог {0}', BRAND)}
        jsonLd={jsonLd}
      />
      <ParticleBackground />
      <div className="bp-app">
        <div className="bp-header">
          <h1 className="bp-title">{t('Блог')}</h1>
          <p className="bp-subtitle">{t('Новости, обновления и статьи от команды {0}', BRAND)}</p>
        </div>

        <div className="bp-list">
          {posts.map((post) => (
            <Link key={post.slug} to={`/blog/${post.slug}`} className="bp-card">
              <div className="bp-card-text">
                <h2 className="bp-card-title">{post.title}</h2>
                <p className="bp-card-desc">{post.description}</p>
              </div>
              <ChevronRight size={18} className="bp-card-arrow" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogPage;
